import './index.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';

import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root')!);
console.log(process.env.GOOGLE_AUTH_CLIENT_ID);
root.render(
  <StrictMode>
    
    <Provider store={store}>
      <GoogleOAuthProvider clientId="250297665401-7hr3gvhp5vt8760obllrlaslgvoigtt4.apps.googleusercontent.com">
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </GoogleOAuthProvider>
    </Provider>
   </StrictMode>
);

reportWebVitals();
